<template>
  <div class="modal" :class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-light">
          Share Link
        </p>
        <button @click="close" class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <section class="columns">
          <div class="column is-half">
            <h4 class="title is-4 has-text-gray">Share Link via Email</h4>
            <div class="field has-addons">
              <p class="control is-expanded has-icons-left">
                <input
                  @keypress="emailField.valid = true"
                  @keypress.enter="addRemove('add')"
                  @keypress.space="addRemove('add')"
                  class="input"
                  type="email"
                  placeholder="jane.doe@example.com"
                  v-model="emailField.email"
                  :class="{ 'is-danger': !emailField.valid }"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </p>
              <p class="control">
                <a @click="addRemove('add')" class="button is-primary">Add</a>
              </p>
            </div>
            <p
              class="help"
              v-if="!emailField.valid"
              :class="{ 'is-danger': !emailField.valid }"
            >
              Email not valid
            </p>
            <br />
            <div class="tags">
              <span
                v-for="(email, index) in shareWith"
                :key="index"
                class="tag is-success is-rounded"
              >
                {{ email }}
                <button
                  @click="addRemove('remove', index)"
                  class="delete"
                ></button>
              </span>
            </div>
          </div>
          <div class="column is-half">
            <h4 class="title is-4 has-text-gray">Personalize your Message</h4>
            <div class="control">
              <textarea
                placeholder="Hey, check out this awesome document!"
                v-model="message"
                class="textarea"
              ></textarea>
            </div>
          </div>
        </section>
      </section>
      <footer class="modal-card-foot">
        <button
          @click="shareLink"
          class="button is-success"
          :disabled="shareWith.length === 0"
        >
          <span class="icon">
            <i class="fas fa-paper-plane"></i>
          </span>
          <span>
            Send link
          </span>
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export default {
  name: 'ShareLink',
  props: ['link'],
  data() {
    return {
      emailField: {
        email: '',
        valid: true
      },
      shareWith: [],
      message: ''
    };
  },
  computed: {
    show() {
      return Boolean(this.link);
    }
  },
  methods: {
    close(data) {
      this.message = '';
      this.shareWith = [];
      this.$emit('close', data);
    },
    shareLink() {
      const endpoint = this.$API.shareLink();
      let body = {
        shareWith: this.shareWith,
        message: this.message,
        link: this.link
      };
      this.$axios
        .post(endpoint, body)
        .then(response => {
          this.$notify({
            group: 'alert',
            title: 'SUCCESS!',
            text: 'Your link has been sent successfully!',
            type: 'success'
          });
          this.close(response.data);
        })
        .catch(e => {
          this.$notify({
            group: 'alert',
            title: 'FAILED!',
            text: 'Unable to send the link. Please try again later.',
            type: 'error'
          });
          console.info('ERROR: ', e);
        });
    },
    addRemove(action, i) {
      switch (action) {
        case 'remove':
          this.shareWith.splice(i, 1);
          break;
        case 'add':
          if (!re.test(this.emailField.email)) {
            return (this.emailField.valid = false);
          }
          if (this.shareWith.includes(this.emailField.email)) {
            return (this.emailField.email = '');
          }
          this.shareWith.push(this.emailField.email);
          this.emailField.email = '';
          break;
      }
    }
  }
};
</script>
